type PaymentOption = {
  provider: string
}

export function isDepositPaymentOption({provider}: PaymentOption): boolean {
  return provider === 'enovipayCoinspaid'
}

/**
 * The minimum a deposit into a factorised Tauro account must reach (PT-7173). The backend puts
 * the campaign minimum qualifying deposit into the account minimum, in the account currency. The
 * regular rule may pick the lower client minimum instead, so an unfunded factorised account never
 * goes below the account minimum. A funded account takes no deposit and the backend adds no
 * campaign minimum for it.
 */
export function applyTauroMinimumDeposit(
  minimumDeposit: number,
  isUnfundedFactorised: boolean,
  accountMinimumDeposit: number | null | undefined,
): number {
  if (!isUnfundedFactorised || !accountMinimumDeposit) return minimumDeposit
  return Math.max(minimumDeposit, accountMinimumDeposit)
}
